<template>
  <n-form
    ref="formRef"
    inline
    :label-width="80"
    :model="formValue"
    label-placement="left"
    :rules="rules"
    :size="size"
  >
    <n-form-item label="用户姓名" path="user.name">
      <n-input v-model:value="formValue.name" placeholder="输入姓名" />
    </n-form-item>
    <n-form-item label="电话号码" path="phone">
      <n-input v-model:value="formValue.phone" placeholder="电话号码" />
    </n-form-item>
    <n-form-item>
      <n-button type="primary" attr-type="button" @click="handleValidateClick">
        查询
      </n-button>
      <n-button type="warning" attr-type="button" @click="handleValidateReset" class="reset">
        重置
      </n-button>
    </n-form-item>
  </n-form>
  <n-data-table
      :columns="columns"
      :data="data"
      :pagination="pagination"
  />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { NButton } from 'naive-ui'
import { formatTime } from "@/utils/timeUtils";
import axios from "axios";


const formValue = ref({
    name: '',
    phone: ''
})

const columns = [
    {
        title: '姓名',
        key: 'name',
        align: 'center'
    },
    {
        title: '联系方式',
        key: 'phone',
        align: 'center'
    },
    {
        title: '邮箱地址',
        key: 'email',
        align: 'center'
    },
    {
        title: 'WeChat',
        key: 'wechat',
        align: 'center'
    },
    {
        title: '咨询问题类型',
        key: 'memo',
        align: 'center'
    },
    {
        title: '留资时间',
        key: 'create_date',
        align: 'center'
    }
];

const pagination = ref({
    pageSize: 10,
    showSizePicker: true,
    prefix({ itemCount }) {
        return `共${itemCount}条`
    }
});

const data = ref([]);

const getReport = async () => {
    try {
        const response = await axios.post(
            'https://www.btmusa.cn/api/queryLawContactList',
            formValue.value // 将表单值作为请求体发送
        );
        data.value = response.data.data.map(item => ({
            ...item,
            finished_time_formatted: formatTime(item.finished_time)
        })); 
        pagination.value.itemCount = response.data.data.length; // 设置总记录数
        console.log('Pagination total:', pagination.value.itemCount);
    } catch (error) {
        console.error('获取报告失败', error);
    }
};
const handleValidateClick = async () => {
  getReport();
}

const handleValidateReset = async () => {
  formValue.value = {
    name: '',
    phone: ''
  };
  getReport();
}


onMounted(() => {
    getReport();
});
</script>
<style scoped>
.timeline-content {
  display: flex;
  flex-direction: column;
}

.timeline-time {
  display: flex;
  font-size: 0.9em;
  padding-top: 3px;
  color: #666;
}

.timeline-text {
  font-size: 1em;
  color: #333;
  padding-top: 5px;
}
.reset{
  margin-left: 30px;
}
</style>